import mixpanel from "mixpanel-browser";

const token =
  (import.meta.env.VITE_MIXPANEL_TOKEN as string | undefined) ??
  "c449803985e406d73a1c00b0ee5dcd88";
const isDev = import.meta.env.DEV;

if (token) {
  mixpanel.init(token, {
    debug: isDev,
    track_pageview: true,
    persistence: "localStorage",
    autocapture: false,
    record_sessions_percent: 100,
    api_host: "https://api-eu.mixpanel.com",
  });
}

// ── Generic event tracker ───────────────────────────────────

export function trackEvent(
  name: string,
  properties: Record<string, unknown>,
) {
  if (!token) return;
  mixpanel.track(name, properties);
}

// ── User lifecycle ──────────────────────────────────────────

export function identifyUser(
  userId: string,
  traits: { email: string; plan: string },
) {
  if (!token) return;
  mixpanel.identify(userId);
  mixpanel.people.set(traits);
}

export function resetUser() {
  if (!token) return;
  mixpanel.reset();
}
